@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Pennsylvania</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">
        UM Coverage
        <span
          aria-hidden="true"
          class="axis-required-indicator"
          >*</span
        >
      </h3>
      <!-- UM Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4; track $index) {
          @if (control.formControlName.startsWith("UM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Readonly UM Dropdowns -->
      <div class="axis-grid">
        @if ((baseRules?.["UM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="um_splitminlimits_15k_30k-pdffield-pennsylvania">
                {{ controls[8].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="um_combinedsingleminlimit_35k-pdffield-pennsylvania">
                {{ controls[9].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UM_LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[14].label }}</label>
              <div
                id="um_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-pennsylvania"
              >
                {{ controls[14].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 1) {
        <h3 class="axis-h5">
          {{ controls[0].label }}
          <span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
        </h3>
        <p>Stacked coverage is NOT available for policies covering five vehicles or more.</p>
        <p>If your policy provides coverage for fewer than five vehicles, please select one of the following:</p>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UIM Radio group level two -->
      <h3 class="axis-h5">
        UIM Coverage
        <span
          aria-hidden="true"
          class="axis-required-indicator"
          >*</span
        >
      </h3>
      @if (controls?.length >= 5) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[4].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[4].formControlName)?.touched &&
              reactiveForm.get(controls[4].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[4].formControlName }}">
            @for (control of controls[4].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[4].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[4].formControlName)?.touched) {
            @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (controls?.length >= 6) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[5].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[5].formControlName)?.touched &&
              reactiveForm.get(controls[5].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[5].formControlName }}">
            @for (control of controls[5].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[5].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[5].formControlName)?.touched) {
            @if (reactiveForm.get(controls[5].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4; track $index) {
          @if (control.formControlName.startsWith("UIM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div
              class="axis-col-sm-6 axis-col-md-6"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(control.formControlName)?.value === null ||
                  reactiveForm.get(control.formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(control.formControlName)?.touched &&
                  reactiveForm.get(control.formControlName)?.invalid,
              }"
            >
              <div class="axis-form-group">
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Readonly UIM Dropdowns -->
      <div class="axis-grid">
        @if ((baseRules?.["UIM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="uim_splitminlimits_15k_30k-pdffield-pennsylvania">
                {{ controls[12].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UIM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[13].label }}</label>
              <div id="uim_combinedsingleminlimit_35k-pdffield-pennsylvania">
                {{ controls[13].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UIM_LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[15].label }}</label>
              <div
                id="uim_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-pennsylvania"
              >
                {{ controls[15].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <!-- UIM Radio group level one -->
      @if (controls?.length >= 4) {
        <h3 class="axis-h5">
          {{ controls[3].label }}
          <span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
        </h3>
        <p>Stacked coverage is NOT available for policies covering five vehicles or more.</p>
        <p>If your policy provides coverage for fewer than five vehicles, please select one of the following:</p>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[3].formControlName)?.touched) {
            @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Pennsylvania</h2>

  <!-- UM Reject Text -->
  @if (baseRules?.Reject_um_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label
        id="rejectuim_uimbiuimpd_leveltwo_radio-pdffield-pennsylvania"
        class="axis-control-label"
      >
        {{ textValues?.Reject_UM_Text }}
      </label>
    </div>
  }

  <!-- UM Non Stacked Text -->
  @if (baseRules?.umNonStacked_LevelOne_Radio) {
    <div class="axis-form-group">
      <label
        id="rejectuim_uimbiuimpd_leveltwo_radio-pdffield-pennsylvania"
        class="axis-control-label"
      >
        {{ textValues?.UMNonStacked_Text }}
      </label>
      <div>{{ baseRules?.umNonStacked_LevelOne_Radio }}</div>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 8 : 10; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
  <!-- UIM Reject Text -->
  @if (baseRules?.Reject_uim_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UIM_Text }}
      </label>
    </div>
  }
  <!-- UIM Non Stacked Text -->
  @if (baseRules?.Nonstacked_uim_Options_LevelOne_Radio) {
    <div class="axis-form-group">
      <label
        id="rejectuim_uimbiuimpd_leveltwo_radio-pdffield-pennsylvania"
        class="axis-control-label"
      >
        {{ textValues?.UIMNonStacked_Text }}
      </label>
      <div>{{ baseRules?.Nonstacked_uim_Options_LevelOne_Radio }}</div>
    </div>
  }
  <div class="axis-grid">
    @for (control of controls | slice: 12; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}
